import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { HttpModule} from '@angular/http';
import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { MapasPage } from '../pages/mapas/mapas';
import { ListPage } from '../pages/list/list';
import { LoginPage } from '../pages/login/login';
import { CalendarioPage } from '../pages/calendario/calendario';
import { PicajesPage } from '../pages/picajes/picajes';
import { VehiculosPage } from '../pages/vehiculos/vehiculos';
import { InformesPage } from '../pages/informes/informes';
import { TrabajadoresPage } from '../pages/trabajadores/trabajadores';
import { ObrasPage } from '../pages/obras/obras';
import { ZonaObraPage } from '../pages/zona-obra/zona-obra';
import { EmpresasPage } from '../pages/empresas/empresas';
import { TurnosPage } from '../pages/turnos/turnos';
import { AsignarPage } from '../pages/asignar/asignar';
import { TurnoSimpleModal } from '../pages/asignar/mod-turno-simple';
import { CopiarPatronModal } from '../pages/asignar//mod-copiar-patron';
import { UserPage } from '../pages/user/user';
import { UserlinPage } from '../pages/userlin/userlin';
import { ObjetosPage } from '../pages/objetos/objetos';
import { VerlistaPage } from '../pages/verlista/verlista';
import { ObjetoslinPage } from '../pages/objetoslin/objetoslin';
import { GruposPage } from '../pages/grupos/grupos';
import { TictrabajadoresPage } from '../pages/tictrabajadores/tictrabajadores';
import { TicketsPage } from '../pages/tickets/tickets';
import { AlbaranesPage } from '../pages/albaranes/albaranes';
import { AlbtrabajadoresPage } from '../pages/albtrabajadores/albtrabajadores';
import { VacacionesPage } from '../pages/vacaciones/vacaciones';
import { ConfigPage } from '../pages/config/config';
import { VerimagenPage } from '../pages/verimagen/verimagen';
import { ReservaslinPage } from '../pages/reservaslin/reservaslin';
import { AvisoslinPage } from '../pages/avisoslin/avisoslin';
import { SalasPage } from '../pages/salas/salas';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { ModalPushPage } from '../pages/modal-push/modal-push';
import { VariablesProvider } from '../providers/variables/variables';
import { FuncionesProvider } from '../providers/funciones/funciones';
import { IonicStorageModule } from '@ionic/storage';
import { EventModalPage } from '../pages/event-modal/event-modal';
import { CabeceraComponent } from '../components/cabecera/cabecera';
import { CompieComponent } from '../components/compie/compie';
import { BotoneraComponent } from '../components/botonera/botonera';
import { TiposDiasModalPage } from '../pages/tipos-dias-modal/tipos-dias-modal';

import { NgModule, LOCALE_ID } from '@angular/core';

import { CalendarModule } from "ion2-calendar";
import { AgmCoreModule } from '@agm/core';
import { File } from '@ionic-native/file';
import { IonicImageViewerModule } from 'ionic-img-viewer';
import { HTTP, HTTPResponse } from '@ionic-native/http';

import { ChatWidgetComponent } from '../components/chat-widget/chat-widget';

import { AiAgentPage } from '../pages/ai-agent/ai-agent';

import { Cordova, IonicNativePlugin, Plugin } from '@ionic-native/core';

//import * as createtable from '../pages/informes/createtable';

@NgModule({
  declarations: [
    TiposDiasModalPage,
    AiAgentPage,
    ChatWidgetComponent,
    ModalPushPage,
    TicketsPage,
    AlbaranesPage,    
    AlbtrabajadoresPage,
    CalendarioPage,
    TrabajadoresPage,
    TictrabajadoresPage,
    PicajesPage,
    AvisoslinPage,
    VehiculosPage,    
    ObrasPage,
    ZonaObraPage,
    UserlinPage,    
    UserPage,
    EmpresasPage,
    ConfigPage,
    EventModalPage,
    TurnosPage,    
    AsignarPage,
    TurnoSimpleModal,
    CopiarPatronModal,        
    VacacionesPage,     
    CabeceraComponent,
    CompieComponent,
    BotoneraComponent,
    InformesPage,
    ObjetosPage,    
    SalasPage,    
    ObjetoslinPage,
    GruposPage,    
    MyApp,
    LoginPage,
    HomePage,
    VerimagenPage,    
    VerlistaPage, 
    ReservaslinPage, 
    MapasPage,   
    ListPage
  ],
  imports: [
    CalendarModule,
    BrowserModule,
    IonicModule.forRoot(MyApp),
    IonicStorageModule.forRoot(),
    AgmCoreModule.forRoot({apiKey: 'AIzaSyBZ0HDlhyETGF1F5VGf8LdakCEQ0YwSpcQ'}),
    HttpModule,
    IonicImageViewerModule,
    
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    TiposDiasModalPage,
    AiAgentPage,
    ChatWidgetComponent,
    ModalPushPage,
    MyApp,
    LoginPage,
    ObrasPage,
    ZonaObraPage,
    EmpresasPage,
    UserPage,
    UserlinPage,
    TurnosPage,  
    ConfigPage,  
    AsignarPage,
    TurnoSimpleModal,
    CopiarPatronModal,
    VehiculosPage, 
    VacacionesPage,     
    TrabajadoresPage,
    TictrabajadoresPage,
    AlbtrabajadoresPage,    
    TicketsPage,
    AlbaranesPage,
    ObjetosPage,
    ObjetoslinPage,
    AvisoslinPage,
    EventModalPage,
    GruposPage,   
    SalasPage, 
    VerimagenPage,
    VerlistaPage,    
    HomePage,
    PicajesPage,    
    InformesPage,  
    CalendarioPage,
    ReservaslinPage,
    MapasPage,   
    ListPage
  ],
  providers: [
  { provide: LOCALE_ID, useValue: "es-ES" },
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    VariablesProvider,
    FuncionesProvider,
    //CalendarModule,
    File,
    HTTP
  ],
  exports: [ ChatWidgetComponent ],
})

export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts